import { render } from "./NumberPhonePanel.vue?vue&type=template&id=2abf949c&scoped=true&ts=true"
import script from "./NumberPhonePanel.vue?vue&type=script&lang=ts"
export * from "./NumberPhonePanel.vue?vue&type=script&lang=ts"

import "./NumberPhonePanel.vue?vue&type=style&index=0&id=2abf949c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abf949c"]])

export default __exports__